import { fixedLimts } from 'views/TirePressure/util';
import { fourTiresArr, graderSixTiresArr, sixTiresArr } from './constants';
import { convertKpaToPsi } from 'utils/helpers/unitSystem';

// fnctncs
export const isOverMax = (
  value: number,
  maxValue: number,
  minValue: number
) => {
  if (maxValue == null || minValue == null) return false;

  // Check if value is within the range
  return !(value >= minValue && value <= maxValue);
};
export const tirePressureOrTemperatureCalcOnAssetType = (
  tireData: any,
  metricType: string,
  limits: any,
  unitSystem: string,
  assetType: string,
  customerCode: string
) => {
  try {
    const lowerCaseMetricType = metricType.toLowerCase();

    // @ts-expect-error ignore this we have it defined
    const limitsData = fixedLimts[unitSystem][lowerCaseMetricType];
    const isTemperature = lowerCaseMetricType === 'temperature';

    const currentValues = isTemperature
      ? tireData.tireCurrentTemperature
      : tireData.tireCurrentStatus;

    const result: any = {};

    let tireNumberSystem: string[] = [];

    if (assetType === 'haul_truck') {
      tireNumberSystem = sixTiresArr;
    }
    if (
      ['light_truck', 'loader', 'heavy_truck', 'dozer', 'drill'].includes(
        assetType
      )
    ) {
      tireNumberSystem = fourTiresArr;
    }
    if (assetType === 'grader') {
      tireNumberSystem = graderSixTiresArr;
    }

    tireNumberSystem.forEach((code, index) => {
      const tireNumber = index + 1;
      const value = Number(currentValues[code] ?? 0);
      let tireLimit = limits.find((item: any) => item.tireCode === code);

      // incase of temp use value from config, else use it from be,
      // also incase of imperial we need to convert as values are saved on be in metric always
      const maxValue = isTemperature
        ? limitsData?.maxValue
        : unitSystem === 'metric'
        ? tireLimit.maxPressure
        : convertKpaToPsi(tireLimit?.maxPressure);
      const minValue = isTemperature
        ? limitsData?.minValue
        : unitSystem === 'metric'
        ? tireLimit.minPressure
        : convertKpaToPsi(tireLimit?.minPressure);

      tireLimit = {
        ...tireLimit,
        minValue,
        maxValue,
      };

      result[`p${tireNumber}`] = value;
      result[`p${tireNumber}Limits`] = tireLimit;
      const isOverMaxRes = isOverMax(value, maxValue, minValue);
      result[`isP${tireNumber}WarninigMax`] = isOverMaxRes;
    });

    return result;
  } catch (error) {
    console.log(error);
    return {};
  }
};
